import { render, staticRenderFns } from "./masterData.vue?vue&type=template&id=3a24170f&scoped=true"
import script from "./masterData.vue?vue&type=script&lang=js"
export * from "./masterData.vue?vue&type=script&lang=js"
import style0 from "./masterData.vue?vue&type=style&index=0&id=3a24170f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a24170f",
  null
  
)

export default component.exports